import { Box, IconButton } from '@mui/material';
import { ATSAutomationListTestIds } from 'data-testids/ATS';
import { ReactComponent as DeleteIcon } from 'assets/icons/icon_trash.svg';
import { useRef } from 'react';

interface DeleteAutomationsButtonProps {
  questionId: number;
  onDelete: (questionId: number) => void;
}

export const DeleteAutomationsButton: React.FC<DeleteAutomationsButtonProps> = ({
  questionId,
  onDelete,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  return (
    <Box>
      <IconButton
        ref={buttonRef}
        onMouseDown={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onPointerDown={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onDelete(questionId);
        }}
        data-testid={`${ATSAutomationListTestIds.DELETE_AUTOMATIONS_BUTTON}-${questionId}`}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};
